import { createProviderToken } from '@core/common-legacy';
import {
  ReportsComponentHttpClientService,
  ReportsDashboardsHttpClientService,
} from '@core/reports-types';

export const {
  inject: injectReportsComponentHttpClient,
  provide: provideReportsComponentHttpClient,
} = createProviderToken<ReportsComponentHttpClientService>('ReportsComponentHttpClientService')();

export const {
  inject: injectReportsDashboardHttpClient,
  provide: provideReportsDashboardHttpClient,
} = createProviderToken<ReportsDashboardsHttpClientService>('ReportsDashboardHttpClientService')();
